import React from 'react';
import { Icon } from '@iconify/react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function SortableMagazineCard({
  id,
  disabled,
  children,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.55 : 1,
    zIndex: isDragging ? 2 : undefined,
  };

  return (
    <article
      ref={setNodeRef}
      style={style}
      className={`klub-magazine-card${isDragging ? ' is-dragging' : ''}`}
    >
      {!disabled ? (
        <button
          type="button"
          className="klub-magazine-card__drag"
          aria-label="Déplacer"
          title="Glisser pour réordonner"
          {...attributes}
          {...listeners}
        >
          <Icon icon="mdi:drag" aria-hidden />
        </button>
      ) : null}
      {children}
    </article>
  );
}

export default SortableMagazineCard;
